import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

import { Observable, BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';
import * as moment from 'moment/moment';

import { User } from '../classes/user';
 
const httpOptions = {
  headers: new HttpHeaders(
    { 
      'Content-Type': 'application/json'
    }
  )
};

@Injectable()
export class AuthenticationService {

  private baseUrl = environment.apiUrl;

  constructor( private http: HttpClient, private router: Router, private cookieService: CookieService ) { }

  loginUser (email, password, remember) {
    if(remember == true){
      var expireDate = moment.utc().add(1, 'year').toDate();
      var expireString = '365d';
    }
    else if(!remember || remember == false){
      var expireDate = moment.utc().add(2, 'hours').toDate();
      var expireString = '2h';
    }
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'ExpireTime': expireString } ) };
    return this.http.post(this.baseUrl + '/login', {"email": email, "password": password}, httpOptions)
    .map(
      (data: any) => {
        this.cookieService.set('perchedToken', data.token, expireDate);
        this.cookieService.set('perchedUser', JSON.stringify(data), expireDate);
      },
      error => {
        return error;
      });
  }

  logout() {
    let httpOptions = {
      headers: new HttpHeaders(
        { 
          'Content-Type': 'application/json',
          'Token': this.cookieService.get('perchedToken')
        }
      )
    };
    return this.http.get(this.baseUrl + '/logout', httpOptions).subscribe(
      (data: any) => {
        this.cookieService.deleteAll();
        this.router.navigate(['/about']);
      },
      error => {
        console.log(JSON.stringify(error));
      });
  }

  requestPasswordResetLink (email) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json' } ) };
    let payload = { "email": email };
    return this.http.post(this.baseUrl + '/forgotPassword', payload, httpOptions);
  }

  resetPassword (resetToken, password, confirmPassword) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json' } ) };
    let payload = { "password": password, "confirmPassword": confirmPassword };
    return this.http.post(this.baseUrl + '/resetPassword/' + resetToken, payload, httpOptions);
  }

  validateToken(token) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.get(this.baseUrl + '/tokens/' + token, httpOptions);
  }

  getLoggedInUser() : string {
    return this.cookieService.get('perchedUser');
  }

  getFirstName() : string {
    var parsed = JSON.parse(this.cookieService.get('perchedUser'));
    return parsed.profile.firstName;
  }

  getFullName() : string {
    var parsed = JSON.parse(this.cookieService.get('perchedUser'));
    return parsed.profile.firstName + " " + parsed.profile.lastName;
  }

  getUserImage() : string {
    var parsed = JSON.parse(this.cookieService.get('perchedUser'));
    if (!parsed.profileImageUrl) return null;
    return parsed.profileImageUrl;
  }

  isAdmin() : boolean {
    var parsed = JSON.parse(this.cookieService.get('perchedUser'));
    return parsed.isAdmin;
  }

  getEmail() : string {
    var parsed = JSON.parse(this.cookieService.get('perchedUser'));
    return parsed.email;
  }

  id() : string {
    var parsed = JSON.parse(this.cookieService.get('perchedUser'));
    return parsed.id;
  }

  private isLoggedIn() : boolean {
    if(this.cookieService.get('perchedUser')){
      return true;
    }
    else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/services/authentication.service.ts